module.exports = __webpack_public_path__ + "img/Kids-Who-Farm.6b61a61c.png";